import React from 'react';
import { PropTypes } from 'prop-types';
import FetchContainer, { defaultProps } from './FetchContainer';
import { getJWT } from '../../redux/authentication/utils';
import intlEquipped from '../../hocs/intlEquipped';
import { fetchContainerPropTypes } from '../../types';

const IntlEquippedFetchContainer = intlEquipped(FetchContainer);

const BffFetchContainer = ({ endpoint, options, ...rest }) => (
    <IntlEquippedFetchContainer
        url={ `${CONFIG.myPage.apiHost}${endpoint}` }
        options={{
            ...options,
            headers: {
                Authorization: getJWT(),
                Publisher: CONFIG.myPage.publication,
            },
        }}
        { ...rest }
    />
);

const { url, ...bffFetchContainerPropTypes } = fetchContainerPropTypes;

BffFetchContainer.propTypes = {
    ...bffFetchContainerPropTypes,
    options: PropTypes.shape({}),
    endpoint: PropTypes.string.isRequired,
};

BffFetchContainer.defaultProps = defaultProps;

export default IntlEquippedFetchContainer;
export { BffFetchContainer };
